import type {
  CoreCoachCertificatesCreateParams,
  CoreCoachCertificatesDeleteParams,
  CoreCoachCertificatesReadParams,
  CoreCoachCertificatesUpdateParams,
} from '../types/core/methods';
import type {CertificateApiModel} from './types';

import {EntityStore} from '../utils/entityStore';

export class CertificateStore<
  T extends CertificateApiModel = CertificateApiModel,
> extends EntityStore<
  T,
  CoreCoachCertificatesReadParams,
  CoreCoachCertificatesCreateParams,
  CoreCoachCertificatesUpdateParams,
  CoreCoachCertificatesDeleteParams
> {}

export const certificateStore = new CertificateStore('certificate', {
  create: 'coach.certificates.create',
  delete: 'coach.certificates.delete',
  fetch: 'coach.certificates.read',
  update: 'coach.certificates.update',
});
